<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  imageSource: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="flex items-center max-w-[174px] p-1 pr-3">
    <div class="relative">
      <img
        :src="imageSource"
        :alt="title"
        class="bg-cover w-[32px] h-[32px] rounded-full mr-2"
      />

      <div
        class="absolute flex items-center justify-center rounded-full border-white border-2 bg-yellow-300 w-[18px] h-[18px] bottom-[-4px] right-[4px]"
      >
        <fa-icon :icon="['fas', 'hotel']" class="text-black text-[7px]" />
      </div>
    </div>
    <div class="max-w-[120px]">
      <p class="h300 truncate">{{ title }}</p>
    </div>
  </div>
</template>
